import { useNavigate } from "react-router-dom";
import type { AppRole } from "@/shared/config/navigation";

export type PaymentsTab = "payments" | "overdue" | "cancelled" | "bank" | "discount-scale";

interface PaymentsNavigationProps {
	activeTab: PaymentsTab;
	role: AppRole;
}

export function PaymentsNavigation({ activeTab, role }: PaymentsNavigationProps) {
	const navigate = useNavigate();
	const isStaff = role === "admin" || role === "super";

	const tabStyle = (active: boolean) => ({
		background: active ? "var(--crm-primary, #2563eb)" : "#f1f5f9",
		color: active ? "#ffffff" : "#475569",
		border: "none",
		borderRadius: "8px",
		padding: "8px 16px",
		fontWeight: 600,
		cursor: "pointer",
		transition: "all 0.2s ease",
	});

	return (
		<div style={{ display: "flex", gap: "10px", marginBottom: "24px", flexWrap: "wrap" }}>
			<button
				type="button"
				style={tabStyle(activeTab === "payments")}
				onClick={() => navigate("/payments")}
			>
				To'lovlar jurnali
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "overdue")}
				onClick={() => navigate("/payments/overdue")}
			>
				To'lov grafiklari
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "cancelled")}
				onClick={() => navigate("/payments/cancelled")}
			>
				Bekor qilingan sotuvlar
			</button>
			{isStaff && (
				<>
					<button
						type="button"
						style={tabStyle(activeTab === "bank")}
						onClick={() => navigate("/payments/bank")}
					>
						Bank rekvizitlari
					</button>
					<button
						type="button"
						style={tabStyle(activeTab === "discount-scale")}
						onClick={() => navigate("/payments/discount-scale")}
					>
						Chegirma shkalasi
					</button>
				</>
			)}
		</div>
	);
}
